import React, { useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
// import CssBaseline from '@mui/material/CssBaseline';
import { Alert, Snackbar } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// eslint-disable-next-line import/no-named-as-default
import Pages from './Components/Pages';
import ROUTES from './Configs/routes';
import store from './Redux/store';
import './App.css';
import Elements from './Components/Elements';
import {
  // getToken,
  getUserData,
} from './Utils/storages';
import AlertContext from './Context/AlertContext';
import ConfirmationContext from './Context/ConfirmationContext';
import InitializationContext from './Context/InitializationContext';
import ReqInContext from './Context/ReqInContext';
// import { setClientToken } from './Utils/helpers';

function App() {
  const userData = getUserData();
  // const token = getToken();
  const role = userData?.role_id?.toLowerCase();
  // const blacklistRoutesAfterSignIn = [];
  const blacklistRoutesAfterSignIn = ['/signin', '/signup', '/otp'];

  const authRoutes = () => (
    <>
      <Route index element={<Pages.Onboarding />} />
      <Route path={ROUTES.signin()} element={<Pages.SignIn />} />
      <Route path={ROUTES.signup()} element={<Pages.SignUp />} />
      <Route path={ROUTES.signupConfirmation()} element={<Pages.SignupConfirmation />} />
      <Route path={ROUTES.forgotPassword()} element={<Pages.ForgotPassword />} />
      <Route
        path={ROUTES.resetPassConfirmation()}
        element={<Pages.ResetPassConfirmation />}
      />
      <Route
        path={ROUTES.resetPassSuccess()}
        element={<Pages.ResetPassSuccess />}
      />
      <Route path={ROUTES.createNewPass()} element={<Pages.CreateNewPass />}>
        <Route path=":email" element={<Pages.CreateNewPass />} />
        <Route path=":email/:token" element={<Pages.SignupVerif />} />
      </Route>
      <Route path={ROUTES.otp()} element={<Pages.OTP />} />
      <Route path={ROUTES.signupVerif()} element={<Pages.SignupVerif />}>
        <Route path=":email" element={<Pages.SignupVerif />} />
        <Route path=":email/:token" element={<Pages.SignupVerif />} />
      </Route>
      <Route path={ROUTES.cart()} element={<Pages.Cart />} />
      <Route path={ROUTES.market()}>
        <Route index element={<Pages.Market />} />
        <Route path="search">
          <Route index element={<Pages.MarketSearch />} />
          {/* <Route path=":productId" element={<Pages.ProductDetails />} /> */}
        </Route>
        {/* <Route path="bid">
          <Route index element={<Pages.MarketMyBid />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="my-orders">
          <Route index element={<Pages.MarketMyOrder />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="sale-item">
          <Route index element={<Pages.MarketSaleItem />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path=":productId" element={<Pages.ProductDetails />} /> */}
      </Route>
    </>
  );

  const adminRoutes = () => (
    <>
      <Route index element={<Pages.AdminOverview />} />
      <Route path={ROUTES.home()} element={<Pages.AdminOverview />} />
      <Route path={ROUTES.overview()} element={<Pages.AdminOverview />} />
      <Route path={ROUTES.request()} element={<Pages.AdminHome />} />
      <Route path={ROUTES.requestIn()} element={<Pages.AdminRequestIn2 />}>
        <Route path=":requestId" element={<Pages.AdminRequestIn2 />} />
      </Route>
      <Route path={ROUTES.requestOut()} element={<Pages.AdminRequestOut2 />}>
        <Route path=":requestId" element={<Pages.AdminRequestOut2 />} />
      </Route>
      <Route path={ROUTES.storage()} element={<Pages.AdminStorages2 />} />
      <Route path={ROUTES.couriers()}>
        <Route index element={<Pages.AdminCouriers />} />
        <Route path="all" element={<Pages.AdminAllCouriers />} />
        <Route path="create" element={<Pages.UpdateCourier />} />
        <Route path="update/:courierId" element={<Pages.UpdateCourier />} />
        <Route path="detail/:courierId" element={<Pages.CourierDetails />} />
      </Route>
      <Route path={ROUTES.admins()}>
        <Route index element={<Pages.AllAdmins />} />
        <Route path="create" element={<Pages.UpdateAdmin />} />
        <Route path="update/:adminId" element={<Pages.UpdateAdmin />} />
        <Route path="detail/:adminId" element={<Pages.AdminDetails />} />
      </Route>
      <Route path={ROUTES.customers()}>
        <Route index element={<Pages.AllCustomers />} />
        <Route path="detail/:userId" element={<Pages.CustomerDetails />} />
      </Route>
      <Route path={ROUTES.transactions()}>
        <Route index element={<Pages.AllTransactions />} />
      </Route>
      <Route path={ROUTES.myItems()} element={<Pages.ListMarketMyItems />} />
      <Route path={ROUTES.requestItem()}>
        <Route index element={<Pages.RequestedItems />} />
        <Route path=":requestId" element={<Pages.RequestedItemDetails />} />
      </Route>
      <Route path={ROUTES.market()}>
        <Route index element={<Pages.ListMarket />} />
        <Route path="create" element={<Pages.UpdateMarketItem />} />
        <Route path="requested">
          <Route index element={<Pages.RequestedItems2 />} />
          <Route path=":requestId" element={<Pages.RequestedItemDetails />} />
        </Route>
        <Route path="update/:itemId" element={<Pages.UpdateMarketItem />} />
        <Route path="detail/:itemId" element={<Pages.AdminMarketDetails />} />
      </Route>
      <Route path={ROUTES.extraStorage()} element={<Pages.AdminAddons />} />
      <Route path={ROUTES.subscription()} element={<Pages.ManageSubscriptions />} />
      <Route path={ROUTES.settings()} element={<Pages.AdminSettings />} />
    </>
  );

  const courierRoutes = () => (
    <>
      <Route index element={<Pages.CourierHome />} />
      <Route path={ROUTES.home()} element={<Pages.CourierHome />} />
      <Route path={ROUTES.request()}>
        <Route index element={<Pages.CourierHome />} />
        <Route path=":requestId" element={<Pages.RequestDetails />} />
      </Route>
      <Route
        path={ROUTES.profile()}
        element={<Pages.CourierProfile />}
      />
      <Route path={ROUTES.history()}>
        <Route
          index
          element={(
            <Elements.CourierPageBase>
              <Pages.History />
            </Elements.CourierPageBase>
          )}
        />
        <Route
          path=":historyId"
          element={(
            <Elements.CourierPageBase noNav>
              <Pages.HistoryDetails />
            </Elements.CourierPageBase>
          )}
        />
      </Route>
    </>
  );

  const userRoutes = () => (
    <>
      <Route index element={!userData.subscription ? <Pages.Subscription /> : <Pages.Home />} />
      <Route path={ROUTES.home()} element={<Pages.Home />} />
      <Route path={ROUTES.settings()} element={<Pages.Settings />} />
      <Route path={ROUTES.cart()} element={<Pages.Cart />} />
      {/* <Route path={ROUTES.storage()} element={<Pages.Home />} /> */}
      <Route path={ROUTES.myStorages()}>
        <Route index element={<Pages.MyStorages />} />
        {/* <Route path=":storageId" element={<Pages.StorageInfo />} /> */}
        <Route path=":itemId" element={<Pages.ItemDetails />} />
      </Route>
      <Route path={ROUTES.requestStorage()} element={<Pages.RequestIn />} />
      <Route path={ROUTES.requestReturn()} element={<Pages.RequestReturn />}>
        <Route path=":productId" element={<Pages.RequestReturn />} />
      </Route>
      <Route path={ROUTES.requestOut()} element={<Pages.RequestOut />}>
        <Route path=":productId" element={<Pages.RequestOut />} />
      </Route>
      <Route path={ROUTES.market()}>
        <Route index element={<Pages.Market />} />
        <Route path="search">
          <Route index element={<Pages.MarketSearch />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="bid">
          <Route index element={<Pages.MarketMyBid />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="my-orders">
          <Route index element={<Pages.MarketMyOrder />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="sale-item">
          <Route index element={<Pages.MarketSaleItem />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        <Route path="watchlist">
          <Route index element={<Pages.MarketWatchlist />} />
          <Route path=":productId" element={<Pages.ProductDetails />} />
        </Route>
        {/* <Route path=":productId" element={<Pages.ProductDetails />} /> */}
      </Route>
      <Route path={ROUTES.profile()}>
        <Route
          index
          element={(
            <Elements.PageBase>
              <Pages.Profile />
            </Elements.PageBase>
          )}
        />
        <Route path="update" element={<Pages.UpdateProfile />} />
      </Route>

      <Route path={ROUTES.history()}>
        <Route
          index
          element={(
            <Elements.PageBase noNav>
              <Pages.History />
            </Elements.PageBase>
          )}
        />
        <Route
          path=":historyId"
          element={(
            <Elements.PageBase noNav>
              <Pages.HistoryDetails />
            </Elements.PageBase>
           )}
        />
      </Route>
      <Route path={ROUTES.subscription()} element={<Pages.Subscription />} />
      <Route path={ROUTES.subscriptionSuccess()} element={<Pages.SubscriptionSuccess />} />
      <Route path={ROUTES.subscriptionPackage()}>
        <Route
          index
          element={<Pages.SubscriptionPackage />}
        />
        <Route
          path=":subsType"
          element={<Pages.SubscriptionDetails />}
        />
      </Route>
      <Route path={ROUTES.address()}>
        <Route index element={<Pages.AddressList />} />
        <Route path="update" element={<Pages.UpdateAddress />} />
        <Route path="update/:addressId" element={<Pages.UpdateAddress />} />
      </Route>
      <Route path={ROUTES.sellProduct()} element={<Pages.SellProduct />} />
      <Route path={ROUTES.sellMultiProduct()} element={<Pages.SellMultiProduct />} />
      <Route path={ROUTES.mySubscription()} element={<Pages.MySubscription />} />
      <Route path={ROUTES.requestItem()} element={<Pages.RequestItem />} />
      <Route path={ROUTES.notifications()} element={<Pages.Notifications />} />
      <Route path={ROUTES.purchase()} element={<Pages.PurchaseConfirmation />} />
      <Route path={ROUTES.extraStorage()} element={<Pages.ExtraStorage />} />
      <Route path={ROUTES.extraStorageConfirm()} element={<Pages.ExtraStorageConfirmation />} />
      <Route path={ROUTES.wallet()}>
        <Route index element={<Pages.Wallet />} />
        <Route path="intro" element={<Pages.WalletIntro />} />
        <Route path="terms" element={<Pages.WalletTerms />} />
        <Route path="pin" element={<Pages.WalletPin />} />
        <Route path="history">
          <Route index element={<Pages.WalletHistory />} />
          <Route path=":id" element={<Pages.WalletHistoryDetails />} />
        </Route>
        <Route path="withdraw" element={<Pages.WalletWithdraw />} />
      </Route>
      <Route path={ROUTES.lang()} element={<Pages.Language />} />
    </>
  );

  // alert context configs:START
  const [alertVal, setAlertVal] = useState({
    severity: 'success',
    open: false,
    message: '',
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  });

  const closeAlert = () => {
    setAlertVal({
      ...alertVal,
      open: false,
    });
  };

  const openAlert = (data) => {
    setAlertVal({
      ...alertVal,
      ...data,
      open: true,
    });
  };

  const alertContextValue = useMemo(() => ({
    openAlert,
    closeAlert,
  }), []);
  // alert context configs:END

  // modalConfirmation context configs:START
  const [confirmationProps, setConfirmationProps] = useState(null);

  const handleOpenConfirmation = (data) => {
    setConfirmationProps(data);
  };

  const handleCloseConfirmation = () => {
    setConfirmationProps(null);
  };

  const confirmationValue = useMemo(() => ({
    openConfirmation: handleOpenConfirmation,
    closeConfirmation: handleCloseConfirmation,
  }), []);
  // modalConfirmation context configs:END

  const [firstInit, set1stInit] = useState(true);
  const initializationValue = useMemo(() => ({
    firstInit,
    finishInitialization: () => set1stInit(false),
  }), [firstInit]);

  const [reqInData, setReqInData] = useState([
    // {
    //   name: '', volume: null, tempVolume: '0', id: Date.now(), year: null,
    // },
  ]);
  const [reqInBoxData, setReqInBoxData] = useState([
    // {
    //   name: '', amount: 1, notes: '', dimension: '', id: Date.now(),
    // },
  ]);
  const [step, setStep] = useState(1);
  const reqInValue = useMemo(() => ({
    data: reqInData,
    boxData: reqInBoxData,
    setReqInData,
    setReqInBoxData,
    step,
    setStep,
  }), [reqInData, reqInBoxData, step]);

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {/* <CssBaseline /> */}
        <AlertContext.Provider value={alertContextValue}>
          <ConfirmationContext.Provider value={confirmationValue}>
            <InitializationContext.Provider value={initializationValue}>
              <ReqInContext.Provider value={reqInValue}>
                <Elements.ConfirmationModal
                  open={!!confirmationProps}
                  {...confirmationProps}
                  handleClose={handleCloseConfirmation}
                />
                <Snackbar
                  anchorOrigin={alertVal.anchorOrigin}
                  open={alertVal.open}
                  autoHideDuration={10000}
                  onClose={closeAlert}
                >
                  <Alert onClose={closeAlert} severity={alertVal.severity || 'success'}>
                    <div className="weight-700">{alertVal?.title}</div>
                    {alertVal.message}
                  </Alert>
                </Snackbar>

                <BrowserRouter>
                  <Elements.AdminContainer isAdmin={['admin', 'warehouse manager'].includes(role)}>
                    <Routes>
                      {!!role && blacklistRoutesAfterSignIn.map((path) => (
                        <Route
                          key={path}
                          path={path}
                          element={<Navigate to="/" replace />}
                        />
                      ))}

                      <Route path="/">
                        {['admin', 'warehouse manager'].includes(role) && adminRoutes()}
                        {role === 'kurir' && courierRoutes()}
                        {role === 'user' && userRoutes()}
                        {!role && authRoutes()}
                        <Route path="/oenobank">
                          <Route index element={<Pages.OenoBank />} />
                          <Route path=":page" element={<Pages.OenoBank />} />
                        </Route>
                        <Route path={ROUTES.contactUs()} element={<Pages.ContactUs />} />
                        <Route path={ROUTES.dev()} element={<Pages.Dev />}>
                          <Route path=":devId" element={<Pages.Dev />} />
                        </Route>
                      </Route>

                      {!role
                        ? <Route path="*" element={<Pages.Onboarding />} />
                        : <Route path="*" element={<div>Not found</div>} />}
                    </Routes>
                  </Elements.AdminContainer>
                </BrowserRouter>
              </ReqInContext.Provider>
            </InitializationContext.Provider>
          </ConfirmationContext.Provider>
        </AlertContext.Provider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
